import {
  useGetTracexIntegrationApi,
  useUpdateTracexIntegrationApi,
} from '@/api/integrations';
import type { UpdateTracexIntegrationBody } from '@ditto/shared';
import { toast } from 'sonner';

type UpdateOptions = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useTracexIntegrationService = () => {
  const { data, isPending, error } = useGetTracexIntegrationApi();
  const updateMutation = useUpdateTracexIntegrationApi();

  const updateIntegration = (
    body: UpdateTracexIntegrationBody,
    options?: UpdateOptions
  ) => {
    updateMutation.mutate(body, {
      onSuccess: () => {
        options?.onSuccess?.();
      },
      onError: () => {
        toast.error('Failed to update TraceX integration');
        options?.onError?.();
      },
    });
  };

  return {
    integration: data,
    isPending,
    error,
    updateIntegration,
    isUpdating: updateMutation.isPending,
  };
};
